import { useState } from "react";
import { useT } from "../lib/i18n";
import { renderAdjustReason } from "../lib/adjustReason";
import { TargetExplainerSheet } from "./TargetExplainerSheet";
import type { GoalAdjustment } from "@shared/types";

export function AdjustmentBanner({ adj }: { adj: GoalAdjustment }) {
  const t = useT();
  const key = `lean.dismissed_adj_${adj.id}`;
  const [dismissed, setDismissed] = useState(() => localStorage.getItem(key) === "1");
  const [showWhy, setShowWhy] = useState(false);
  const fresh = (Date.now() / 1000 - adj.applied_at) < 24 * 3600;
  if (dismissed || !fresh) return null;
  return (
    <div className="bg-accent-move/10 border border-accent-move/30 rounded-2xl p-3 flex items-start gap-3">
      <span aria-hidden="true" className="text-xl">📊</span>
      <button onClick={() => setShowWhy(true)} className="flex-1 text-sm text-left press">
        <div>{t("today.adjusted_to", { kcal: adj.daily_calories_after })}</div>
        <div className="text-fg-muted text-sm mt-0.5">{renderAdjustReason(adj.reason, t)}</div>
        <div className="text-accent-move text-sm mt-1 underline">{t("adjust.see_why")}</div>
      </button>
      <button
        onClick={() => { localStorage.setItem(key, "1"); setDismissed(true); }}
        aria-label={t("common.close")}
        className="text-fg-faint p-3 -m-2"
      >
        ✕
      </button>
      {showWhy && <TargetExplainerSheet adj={adj} onClose={() => setShowWhy(false)} />}
    </div>
  );
}
